import React from "react";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
import { cn } from "@/lib/utils";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Bathroom Remodeling",
  description: "Custom showers, premium tile work, and spa-like retreats tailored to your lifestyle.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576980/img/bathroom_spa_retreat.png",
  link: "#"
}, {
  title: "Kitchen Remodeling",
  description: "Functional beauty featuring custom cabinetry, stone countertops, and expert layout design.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576980/img/kitchen_remodel_luxury.png",
  link: "#"
}, {
  title: "Basement Remodeling",
  description: "Transforming underutilized space into high-quality family rooms and living areas.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576980/img/whole_home_renovation_modern.png",
  link: "#"
}];
export default function OurRemodelingExpertise() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="47183" id="our-remodeling-specialties" ref={ref} className="bg-background py-24 relative overflow-hidden text-foreground">
      <div className="container mx-auto px-6">
        <div className={cn("mb-16 text-center transition-all duration-700 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
          <h2 className="text-accent font-sans font-semibold tracking-[0.2em] uppercase text-xs mb-4 border-b border-accent/30 w-fit mx-auto pb-2">
            Expert Craftsmanship
          </h2>
          <h3 className="text-4xl md:text-5xl font-serif text-primary font-medium">
            Our Remodeling Specialties
          </h3>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {services.map((service, i) => <Link key={service.title} to={service.link} className="group block h-full w-full focus:outline-none" data-index={i}>
              <Card className={cn("relative h-[500px] w-full overflow-hidden rounded-sm border-0 bg-transparent shadow-lg transition-all duration-700 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")} style={{
            transitionDelay: `${i * 150}ms`
          }}>
                {}
                <div className="absolute inset-0 bg-cover bg-center transition-transform duration-1000 ease-out will-change-transform group-hover:scale-105" style={{
              backgroundImage: `url(${service.image})`
            }} />

                {}
                <div className="absolute inset-0 bg-gradient-to-t from-primary/95 via-primary/40 to-transparent opacity-80 transition-opacity duration-500 group-hover:opacity-90" />

                {}
                <CardContent className="absolute inset-0 flex flex-col justify-end p-8 md:p-10">
                  <div className="transform transition-transform duration-500 ease-out group-hover:-translate-y-2">
                    <h4 className="text-white font-serif text-3xl mb-3 leading-tight">
                      {service.title}
                    </h4>
                    <p className="text-white/85 text-sm md:text-base font-sans font-light leading-relaxed mb-6 max-w-[90%]">
                      {service.description}
                    </p>
                  </div>
                </CardContent>
              </Card>
            </Link>)}
        </div>
      </div>
    </section>;
}